<div class="marge-decoupage" [style.color]="cellule.margeTotal == null || cellule.margeTotal >= 0   ? 'var(--success-color)' : 'var(--error-color)'" title="marge moyenne en % pour '{{cellule.libelleDecoupageRepas.toUpperCase()}}'" >
  {{cellule.margeTotal == null ? ' - ' : cellule.margeTotal + ' %'}}
</div>
